import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { defaultContainerSize, mq } from '../../../styles/mixins';
import { Headline4, ParagraphS } from '../../core/Typography/Typography';

export const Wrapper = styled.section`
  background: ${({ theme }) => theme.colors.core_black};
  color: ${({ theme }) => theme.colors.core_white};
  padding-top: 5.5rem;
`;

export const Title = styled.h2`
  font-family: ${({ theme }) => theme.font.questrial};
  font-size: 3rem;
  font-style: normal;
  font-weight: 400;
  line-height: 3.5rem;
  text-align: left;
  ${defaultContainerSize};
`;

export const SectionContainer = styled.div`
  ${defaultContainerSize};
  padding-top: 4rem;
  padding-bottom: 5rem;
  display: flex;
  flex-direction: column;
  flex: 1;

  ${mq.large(css`
    display: grid;
    grid-template-columns: 18.75rem auto 18.75rem;
    grid-template-rows: minmax(0, 1fr) 163px minmax(0, 1fr);
  `)};
`;

export const SectionContainerTitle = styled.h3`
  ${Headline4};
  letter-spacing: 0;
  text-align: left;
`;

export const SectionContainerDescription = styled.p`
  ${ParagraphS};
  letter-spacing: 0.013rem;
  text-align: left;
`;

export const SectionContainerTopLeft = styled.div`
  grid-column-start: 1;
  grid-column-end: 1;
  grid-row-start: 1;
  grid-row-end: 1;
`;

export const SectionContainerTopRight = styled.div`
  grid-column-start: 3;
  grid-column-end: 3;
  grid-row-start: 1;
  grid-row-end: 1;
`;

export const SectionContainerBottomLeft = styled.div`
  grid-column-start: 1;
  grid-column-end: 1;
  grid-row-start: 3;
  grid-row-end: 3;
`;

export const SectionContainerBottomRight = styled.div`
  grid-column-start: 3;
  grid-column-end: 3;
  grid-row-start: 3;
  grid-row-end: 3;
`;

export const SectionContainerImage = styled.div`
  grid-column-start: 2;
  grid-column-end: 2;
  grid-row-start: 1;
  grid-row-end: 4;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`;
